import {
    makeChatUrl,
    trans,
} from '@frontend/helpers'
import type {ChatDetailsData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {getChatHeaderData} from '@frontend/modules/private/chats/heplers/getChatHeaderData'
import {
    mdiCheckAll,
    mdiMessageReplyText,
} from '@mdi/js'
import clsx from 'clsx'
import {type MouseEvent} from 'react'
import {Link} from 'react-router-dom'
import {CheckboxIconSwitch} from 'swayok-react-mdb-ui-kit/components/Icon/CheckboxIconSwitch'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {ChatActionsMenu} from './ChatActionsMenu'

interface Props {
    miniChat?: boolean
    chat: ChatDetailsData
    className?: string
    selected: boolean
    isLast?: boolean
    disabled?: boolean
    onSelect: (chatId: number) => void
    onChatOpen: (chat: ChatDetailsData) => void
    // Удаление чата.
    onDelete: (chat: ChatDetailsData) => void
    // Прочитать все сообщения в чате.
    onReadAllMessages: (chat: ChatDetailsData) => void
    // Показать окно добавления отзыва о продавце.
    onAddReview: (chat: ChatDetailsData) => void
}

// Отображение списка чатов.
export function ChatsListItem(props: Props) {

    const {
        miniChat,
        chat,
        className,
        selected,
        isLast,
        disabled,
        onSelect,
        onChatOpen,
        onDelete,
        onReadAllMessages,
        onAddReview,
    } = props

    // Отключить стандартную обработку события
    // и предотвратить передачу события родительскому элементу.
    // Если этого не сделать, то совершится переход к сообщениям чата.
    const stopDefaultEvent = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault()
        event.stopPropagation()
    }

    const headerData = getChatHeaderData(chat)

    return (
        <Link
            to={makeChatUrl(chat.id)}
            className={clsx(
                'chats-list-item my-1 py-3 px-1 d-block flex-md-container-row rounded-6',
                chat.hasNotViewedMessages ? 'bg-light-blue' : null,
                className
            )}
            onClick={event => {
                event.preventDefault()
                onChatOpen(chat)
            }}
        >
            <div className="flex-container-row flex-1">
                <div className="me-3 flex-shrink-0 d-flex flex-column flex-md-row align-items-start justify-content-start">
                    {!miniChat && (
                        <div className="px-2 mx-1">
                            <CheckboxIconSwitch
                                active={selected}
                                disabled={disabled}
                                onClick={event => {
                                    stopDefaultEvent(event)
                                    onSelect?.(chat.id)
                                }}
                            />
                        </div>
                    )}
                    <div className="mt-2 mt-md-0 ms-2 ms-md-2 flex-shrink-0">
                        <div
                            className="d-block img img-thumbnail"
                            style={{
                                backgroundImage: `url("${headerData.coverImage}")`,
                            }}
                        />
                    </div>
                </div>
                <div
                    className={clsx(
                        'flex-1 d-flex flex-column-reverse align-items-stretch justify-content-start',
                        miniChat ? null : 'flex-md-row'
                    )}
                >
                    <div className="flex-1">
                        <div className="fw-bold">
                            {headerData.sellerName}
                        </div>
                        <div className="lh-sm text-muted">
                            {headerData.title}{headerData.price}
                        </div>
                        <div className="flex-row-center-vertical mt-1">
                            <Icon
                                path={mdiMessageReplyText}
                                size={18}
                                color="muted"
                                className="me-1"
                            />
                            <span>
                                {chat.lastMessage || trans().cabinet.chats.no_last_message}
                            </span>
                        </div>
                    </div>
                    <div
                        className={clsx(
                            'mt-n1 text-nowrap flex-shrink-0 d-flex flex-row justify-content-between align-items-center',
                            miniChat ? null : 'mt-md-1 px-md-3 flex-md-column align-items-md-stretch'
                        )}
                    >
                        <div
                            className={clsx(
                                'flex-row-reverse flex-row-center-vertical',
                                miniChat ? null : 'flex-md-row'
                            )}
                        >
                            {!chat.hasNotViewedMessages && (
                                <Icon
                                    path={mdiCheckAll}
                                    color="green"
                                    className={clsx(
                                        'ms-2',
                                        miniChat ? null : 'ms-md-0 me-md-2'
                                    )}
                                />
                            )}
                            <span>{chat.createdAt}</span>
                        </div>
                        <ChatActionsMenu
                            chat={chat}
                            miniChat={miniChat}
                            isLast={isLast}
                            disabled={disabled}
                            className={clsx(
                                'pe-2 text-end',
                                miniChat ? null : 'mt-md-2 pe-md-0'
                            )}
                            buttonClassName={clsx(
                                'py-1 ps-2 pe-1 d-inline-block',
                                miniChat ? null : 'p-md-2 pb-md-0 me-md-n2'
                            )}
                            onRead={onReadAllMessages}
                            onDelete={onDelete}
                            onAddReview={onAddReview}
                        />
                    </div>
                </div>
            </div>
        </Link>
    )
}
